// @ts-nocheck
/* eslint-disable react/prop-types */
// LiBRARY
import React from 'react';
import { Row, Col, Table, Button, Typography, Form, Pagination, Tag } from 'antd';

import Message from 'shared_components/message';
import PageTitle from 'shared_components/page_title';
import SearchPager from 'shared_components/search_pager';
import { RegexInput } from 'shared_components/pattern_input';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';
import fetchDonors, { fetchPatientsNext } from 'services/blood_bank/extraction';

import './index.css';

const { Text } = Typography;

const columns = [
	{
		title: "DONOR'S ID",
		dataIndex: 'donor_id',
		width: 100,
		fixed: 'left',
	},
	{
		title: 'LAST NAME',
		dataIndex: 'last_name',
		width: 150,
		fixed: 'left',
	},
	{
		title: 'FIRST NAME',
		dataIndex: 'first_name',
		width: 150,
	},
	{
		title: 'MIDDLE NAME',
		dataIndex: 'middle_name',
		width: 150,
	},
	{
		title: 'GENDER',
		dataIndex: 'gender',
		width: 80,
	},
	{
		title: 'BIRTHDATE',
		dataIndex: 'birth_date',
		width: 100,
	},
	{
		title: 'ADDRESS',
		render: record =>
			`${record.address_line_1} ${record.address_line_2 ? record.address_line_2 : ''} ${','} ${
				record.barangay_name
			} ${','} ${record.city_name} ${','} ${record.province_name} `,
		width: 400,
	},
	{
		title: 'BLOOD TYPE',
		dataIndex: 'blood_type_name',
		width: 100,
	},
	{
		title: 'EXTRACTION DATE',
		dataIndex: 'date_created',
		width: 120,
	},
	{
		title: 'EXTRACTION STATUS',
		dataIndex: 'status',
		width: 150,
		fixed: 'right',
		render: status => (
			<Tag
				color={
					status.toUpperCase() === 'EXPIRED'
						? 'red'
						: status.toUpperCase() === 'INVALID'
						? 'red'
						: 'green'
				}
			>
				{status.toUpperCase()}
			</Tag>
		),
	},
];

class Extraction extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			donorName: null,
			data: [],
			loading: false,
			pageSize: GLOBAL_TABLE_PAGE_SIZE,
			count: 0,
			page: 1,
			response: {},
			showPagination: false,
		};
		this.formRef = React.createRef();
	}

	handleSubmit = async () => {
		const { pageSize, page } = this.state;
		const { getFieldsValue } = this.formRef.current;
		const { donorID, donorName } = getFieldsValue();

		this.setState({ loading: true });

		const donors = await fetchDonors(donorName, donorID, pageSize, page);
		console.log(
			'🚀 ~ file: index.js ~ line 96 ~ Extraction ~ handleSubmit= ~ donors',
			donors.results,
		);

		this.setState({
			showPagination: donors.results.length > 0,
			donorName,
			donorID,
			loading: false,
			response: donors,
			count: donors.count,
			data: donors.results,
		});

		console.log(donors);

		if (donors.results.length <= 0) {
			Message.info('No results found');
		}
	};

	onChangeDonorId = () => {
		const { setFieldsValue } = this.formRef.current;
		setFieldsValue({ donorName: '' });
	};

	onFocusDonorId = () => {
		const { setFieldsValue } = this.formRef.current;
		setFieldsValue({ donorName: '' });
	};

	onFocusDonorName = () => {
		const { setFieldsValue } = this.formRef.current;
		setFieldsValue({ donorID: '' });
	};

	handleChangeTableSize = async pageSize => {
		const { donorName, page, donorID } = this.state;
		const donors = await fetchDonors(donorName, donorID, pageSize, page);
		this.setState({
			pageSize,
			response: donors,
			count: donors.count,
			data: donors.results,
		});
	};

	clearInputs = () => {
		const { setFieldsValue } = this.formRef.current;
		this.setState({
			data: [],
			donorID: null,
			donorName: null,
			count: 0,
			showPagination: false,
		});
		setFieldsValue({ donorID: '', donorName: '' });
	};

	onPagination = async page => {
		const { donorName, pageSize, donorID } = this.state;
		const donors = await fetchDonors(donorName, donorID, pageSize, page);
		this.setState({
			pageSize,
			response: donors,
			count: donors.count,
			data: donors.results,
		});
	};

	redirect = donorDetail => {
		this.props.history.push('/bloodbank/extraction/details', { donorDetail: donorDetail });
	};

	render() {
		const { data, loading, pageSize, count, showPagination } = this.state;

		return (
			<div>
				<PageTitle pageTitle="EXTRACTION" />
				<div className="space-y-md"></div>
				<Form
					onFinish={this.handleSubmit}
					ref={this.formRef}
					className="blood-extract-search-form"
					layout="vertical"
				>
					<div className="container">
						<Col className="donor-id">
							<Form.Item label="DONOR'S ID" name="donorID">
								<RegexInput
									regex={/[0-9]/}
									maxLength={100}
									onFocus={this.onFocusDonorId}
									placeholder="Donor's ID"
								/>
							</Form.Item>
						</Col>
						{/* Or */}
						<p className="font-md leading-none text">OR</p>
						<Col className="donor-name">
							<Form.Item label="DONOR'S NAME" name="donorName">
								<RegexInput
									regex={/[A-Za-z0-9, -]/}
									maxLength={100}
									onFocus={this.onFocusDonorName}
									placeholder="Lastname, Firstname"
								/>
							</Form.Item>
						</Col>
						<Col>
							<Form.Item shouldUpdate>
								{({ getFieldsValue }) => {
									const { donorID, donorName } = getFieldsValue();
									const disabled = !(donorID || (donorName && donorName.length > 0));
									return (
										<div className="buttons">
											<Button
												className="form-button"
												shape="round"
												style={{ width: 120 }}
												onClick={this.clearInputs}
											>
												CLEAR
											</Button>
											<Button
												loading={loading}
												className="form-button"
												shape="round"
												type="primary"
												htmlType="submit"
												style={{ width: 120 }}
												disabled={disabled}
											>
												SEARCH
											</Button>
										</div>
									);
								}}
							</Form.Item>
						</Col>
					</div>
				</Form>
				{/* <div className="space-y-md"></div> */}
				<SearchPager
					handleChangeSize={this.handleChangeTableSize}
					pageTotal={count}
					pageSize={pageSize}
				/>
				<div className="space-y-sm"></div>
				<Table
					className="blood-extract-search-table"
					style={{ textTransform: 'uppercase' }}
					dataSource={data}
					pagination={false}
					loading={this.state.loading}
					columns={columns}
					rowKey={record => record.donor_id}
					rowClassName={
						(record => record.status.toUpperCase() === 'EXPIRED', 'INVALID' ? 'disabled-row' : '')
					}
					onRow={record => {
						return {
							onDoubleClick: () => {
								if (
									record.status.toUpperCase() !== 'EXPIRED' &&
									record.status.toUpperCase() !== 'INVALID'
								)
									this.redirect(record);
							},
						};
					}}
					scroll={{ x: 1500 }}
					// scroll={{ y: 'calc(100vh - 420px)' }}
				/>
				{showPagination === true && (
					<div style={{ display: 'flex', marginTop: 25 }}>
						<Pagination
							style={{ marginLeft: 'auto' }}
							pageSize={pageSize}
							total={count}
							onChange={this.onPagination}
						/>
					</div>
				)}
			</div>
		);
	}
}

export default Extraction;
